import React from 'react';
import styled from 'styled-components';
import { mobileMediaQuery } from '../../../Theming';
import { SvgProps } from '../core';

const StyledSVG = styled.svg`
  ${mobileMediaQuery} {
    margin-left: 25px;
    width: 105.16px;
    height: 112.19px;
  }
`;

const HowItworksMobile: React.FC<SvgProps> = ({
  width = 156,
  height = 159,
  className,
}) => {
  return (
    <StyledSVG
      width={width}
      height={height}
      className={className}
      viewBox="0 0 114 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M99.7503 96.7278V27.6364C99.7503 23.9715 98.249 20.4567 95.5765 17.8652C92.9041 15.2738 89.2794 13.8179 85.5 13.8179H28.5C24.7207 13.8181 21.0962 15.274 18.4239 17.8655C15.7516 20.4569 14.2503 23.9716 14.2503 27.6364V96.7278H99.7503ZM99.7503 110.546H14.2503V124.364C14.2503 128.028 15.7517 131.543 18.4242 134.135C21.0966 136.726 24.7212 138.182 28.5007 138.182H85.5007C89.28 138.182 92.9044 136.726 95.5768 134.135C98.2491 131.543 99.7503 128.028 99.7503 124.364V110.546ZM28.5 0H85.5C89.2427 0 92.9487 0.714837 96.4065 2.1037C99.8643 3.49256 103.006 5.52824 105.653 8.09452C108.299 10.6608 110.398 13.7074 111.831 17.0604C113.263 20.4134 114 24.0072 114 27.6364V124.364C114 127.993 113.263 131.587 111.831 134.94C110.398 138.293 108.299 141.339 105.653 143.905C103.006 146.472 99.8643 148.507 96.4065 149.896C92.9487 151.285 89.2427 152 85.5 152H28.5C20.9413 152 13.6922 149.088 8.34746 143.905C3.00267 138.723 0 131.693 0 124.364V27.6364C0 20.3068 3.00267 13.2774 8.34746 8.09452C13.6922 2.91169 20.9413 0 28.5 0ZM57 134.728C54.8863 134.728 52.8202 134.12 51.0628 132.982C49.3054 131.843 47.9357 130.224 47.1269 128.331C46.318 126.437 46.1064 124.353 46.5188 122.343C46.9311 120.333 47.9489 118.486 49.4434 117.037C50.9379 115.588 52.8421 114.601 54.9151 114.201C56.9881 113.801 59.1369 114.006 61.0897 114.79C63.0426 115.574 64.7117 116.902 65.8862 118.606C67.0607 120.31 67.6877 122.314 67.6879 124.364C67.6881 125.725 67.4118 127.072 66.8747 128.33C66.3377 129.588 65.5504 130.73 64.5579 131.693C63.5654 132.655 62.3872 133.419 61.0904 133.939C59.7936 134.46 58.4036 134.728 57 134.728Z"
        fill="#1B2457"
      />
    </StyledSVG>
  );
};

export default HowItworksMobile;
